var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivity = function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3a9 9 0 0 0-9 9H1l3.96 4.03L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7a6.93 6.93 0 0 1-4.213-1.422c-.424-.333-1.032-.334-1.413.048-.4.4-.395 1.06.04 1.421.066.054.128.104.183.146A8.93 8.93 0 0 0 13 21a9 9 0 0 0 0-18zm-1 6a1 1 0 1 1 2 0v3l2.21 1.474a1.075 1.075 0 1 1-1.24 1.753L12 13V9z"
  })));
};
export default SvgActivity;